import { render } from "./SocialChannels.vue?vue&type=template&id=080f6166&scoped=true"
const script = {}

import "./SocialChannels.vue?vue&type=style&index=0&id=080f6166&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080f6166"]])

export default __exports__